<template>
	<div :class="classes">
		<FontAwesomeIcon
			class="trash-button"
			:icon="[ `far`, `trash-can`]"
			@click="$emit( `delete` )"
		/>
	</div>
</template>

<script>

export default {
	name: "BackButton",
	emits: [ "delete", ],
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "MEDIUM",
		},
	},
	computed: {
		classes() {
			return {
				"trash-button-box": true,
				"trash-button-box--small": ( this.size === "SMALL" ),
				"trash-button-box--disabled": this.disabled,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$backButtonColor: $color7-500;
$backButtonColor--disabled: $color1-500;
$backButtonBorderColor: $color7-100;
$backButtonBorderColor--disabled: $color1-100;
$backButtonBorderColor--hover: $color7-200;
$backButtonBackgroundColor--hover: $color7-100;

.trash-button-box {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	border: 0.125rem solid $backButtonBorderColor;
	border-radius: 0.5rem;
	padding: 0.5rem 0.65rem;

	cursor: pointer;

	&:not(.trash-button-box--disabled):hover {
		background-color: $backButtonBackgroundColor--hover;
		border-color: $backButtonBorderColor--hover;
	}
}

.trash-button {
	font-size: 1rem;
	color: $backButtonColor;
}

.trash-button-box--small {
	padding: 0.4rem 0.55rem;

	.trash-button {
		font-size: 0.8rem;
		font-weight: 600;
	}
}

.trash-button-box--disabled {
	border-color: $backButtonBorderColor--disabled;
	cursor: not-allowed;

	.trash-button {
		color: $backButtonColor--disabled;
	}
}
</style>
